import { useAuth } from '../contexts/AuthProvider';
import { baseURL } from '../constants/config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Container, Form, Nav, Navbar } from 'react-bootstrap';
import { AppLink } from '../interfaces/app-link.interface';
import { Link } from 'react-router';
import { Fragment, useState } from 'react';
import { Dot, Search } from 'react-bootstrap-icons';
import { RoutesEnum } from '../routes/routes.enum';

const appPages: Record<string, AppLink[]> = {
  "Menu": [
    {
      title: 'Dashboard',
      url: RoutesEnum.Dashboard,
    },
  ], "Purchases": [
    {
      title: 'Create Purchase Order',
      url: `${RoutesEnum.PurchaseOrderForm}/add`,
    },
    {
      title: 'Purchase Order List',
      url: RoutesEnum.PurchaseOrderList,
    },

  ], "Sales": [
    {
      title: 'Create Sale Order',
      url: `${RoutesEnum.SaleOrderForm}/add`,
    },
    {
      title: 'Sale Order List',
      url: RoutesEnum.SaleOrderList,
    },
  ], "Reports": [
    {
      title: 'Purchase Order Balance Report',
      url: RoutesEnum.PurchaseOrderItemBalance,
    },
    // {
    //   title: 'Sale Order Balance Report',
    //   url: RoutesEnum.SaleOrderItemBalance,
    // },
    {
      title: 'Account Trial Balance',
      url: RoutesEnum.AccountTrialBalance,
    },
    {
      title: 'Agent Account Balances',
      url: RoutesEnum.AgentAccountTrialBalance,
    },
  ], "Masters": [
    {
      title: 'Item Master',
      url: RoutesEnum.ItemList,
    },
    {
      title: 'Brand Master',
      url: RoutesEnum.BrandList,
    },
    {
      title: 'Color Master',
      url: RoutesEnum.ColorList,
    },
  ], "User": [
    {
      title: 'Logout',
      url: RoutesEnum.Logout,
    }
  ]
};
const Header: React.FC = () => {
  const { authInfo, settingInfo, settingModeChange, pageTitle, globalSearch, setShowSearchModal } = useAuth();
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);
  return (
    <header className="header sticky-top">
      <Navbar expand={false} className="navbar navbar-dark bg-dark mb-3">
        <Container fluid>
          <Navbar.Brand>{pageTitle}</Navbar.Brand>
          <div className="d-flex align-items-center gap-2">
            {globalSearch.showBtn &&
              <Search
                size={20}
                onClick={() => setShowSearchModal(true)}
                className='cursor-pointer text-white'
              />
            }
            <Navbar.Toggle className='border-0' aria-controls={`offcanvasNavbar-expand-${false}`} onClick={handleShow} />
          </div>

          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-${false}`}
            aria-labelledby={`offcanvasNavbarLabel-expand-${false}`}
            placement="end"
            show={showOffcanvas}
            onHide={handleClose}
          >
            <Offcanvas.Header closeButton className="bg-primary-subtle">
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${false}`}>
                Welcome {authInfo.user.name}!
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {Object.entries(appPages).map(([section, links], idx) => (
                <Fragment key={`section-${idx}`}>
                  {!!section && <strong className="text-danger small">{section}</strong>}
                  <Nav className="justify-content-end flex-grow-1">
                    {links.map((link, index) => (
                      <Link className='nav-link' to={`${baseURL}${link.url}`} onClick={() => handleClose()} key={`section-${idx}-a-${index}`}>
                        <Dot /> {link.title}
                      </Link>
                    ))}
                  </Nav>
                </Fragment>
              ))}
              <hr />
              <Nav className="justify-content-end flex-grow-1">
                <Form.Check
                  type="switch"
                  id="dark-mode"
                  label="Dark Mode"
                  checked={settingInfo.isDarkMode}
                  onChange={(e) => settingModeChange(e.target.checked)}
                />
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
